import Vue from 'vue';
import VueRouter from 'vue-router';

// 首页
import Home from '../pages/home/index.vue';
// 关于我们
import About from '../pages/about/index.vue';
// 被投企业
import Portfolio from '../pages/portfolio/index.vue';
// 团队
import Team from '../pages/team/index.vue';
// 团队详情
import TeamDetail from '../pages/team/detail.vue'
// 新闻
import News from '../pages/news/index.vue'
// 新闻详情
import NewsDetail from '../pages/news/detail.vue'
// 联系我们
import Contact from '../pages/contact/index.vue'

// 追踪点
import Viewpoint from '../pages/viewpoint/index.vue'
// 追踪点详情
import ViewpointDetail from '../pages/viewpoint/detail.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    meta:{
      title:'Selected Portfolio'
    },
    component: Portfolio
  },
  {
    path: '/team',
    name: 'Team',
    component: Team
  },
  {
    path: '/teamDetail',
    name: 'TeamDetail',
    component: TeamDetail
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/viewpoint',
    name: 'Viewpoint',
    component: Viewpoint
  },
  {
    path: '/viewpointDetail',
    name: 'ViewpointDetail',
    component: ViewpointDetail
  },
  {
    path:'/contact',
    name:"Contact",
    component: Contact
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});
// router.beforeEach((to, from, next) => {
//   if (!to.meta.cacheable) {
//     // 如果路由不可缓存，则更新 key
//     if (window.app && window.app.viewKey) {
//       window.app.viewKey = new Date().getTime();
//     }
//   }
//   next();
// });
export default router;
